import { type GTMAppEventType, GtmEventSchema } from './types'
import { type OsContextValue } from '@wppopen/react'
import { getGtmUserProfileDataFromContext } from './utils'
import { getType } from 'utils'
/**
 *
 * @param eventType - The event to be created.
 * @param osContext - The osContext object from the WPP Open React library.
 * @param additionalData - Additional event specific data to be added to the event.
 * @description This function creates a GTM event data object, which includes the user profile data.
 * @returns The GTM event data object with prefilled user data.
 */
export const createEventData = <T extends GTMAppEventType>(
  eventType: T,
  osContext: OsContextValue | null,
  additionalData: Record<string, any> = {},
): GtmEventSchema => {
  const userProfileData = getGtmUserProfileDataFromContext(osContext)

  return {
    event: getType<GTMAppEventType>(eventType),
    ...userProfileData,
    ...additionalData,
  } satisfies GtmEventSchema
}
